<template>
  <b-card-code
    title="DeFi Protocols Summary"
    no-body
  >
    <b-table
      responsive
      striped
      :items="items"
      :fields="fields"
      class="mb-0 text-center"
    >
    <template #cell(protocol)="data">
      <b-link target="_blank" :href="`${data.item.url}`">
        {{ data.value }}
      </b-link>
    </template>
      <template #cell(logo)="data">
        <b-avatar
          class="mr-1"
          :src="data.value"
          size="sm"
        />
      </template>
      <!-- Optional default data cell scoped slot -->
      <template #cell()="data">
        {{ data.value }}
      </template>
    </b-table>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BTable, BAvatar, BLink, } from 'bootstrap-vue'
import { dFormatter } from '@core/utils/filter'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BLink,
  },
  data() {
    return {
      fields: [
        'id',
        'protocol',
        {
          key: 'logo', label: 'Logo',
        },
        {
          key: '24h_change',
          label: '24H Change',
          tdClass: value => Number(value.split('%')[0]) < 0 ? 'text-danger' : 'text-success'
        },
        {
          key: '7d_change',
          label: '7D Change',
          tdClass: value => Number(value.split('%')[0]) < 0 ? 'text-danger' : 'text-success'
        },
        {
          key: '30d_change',
          label: '30D Change',
          tdClass: value => Number(value.split('%')[0]) < 0 ? 'text-danger' : 'text-success'
        },
        {
          key: 'tvl',
          label: 'TVL',
          tdClass: 'font-weight-bold'
        },
        'dominance',
      ],
      items: [
        {
          id: '1',
          protocol: 'Ref Finance',
          logo: require('@/assets/images/logo/ref-finance.png'),
          "24h_change": '',
          "7d_change": '',
          "30d_change": '',
          tvl: '0',
          dominance: '0%',
          url: 'https://ref.finance/',
        },
        {
          id: '2',
          protocol: 'Burrow',
          logo: require('@/assets/images/logo/burrow.png'),
          "24h_change": '',
          "7d_change": '',
          "30d_change": '',
          tvl: '0',
          dominance: '0%',
          url: 'https://app.burrow.cash/#/deposit',
        },
        {
          id: '3',
          protocol: 'Meta Pool',
          logo: require('@/assets/images/logo/meta-pool.png'),
          "24h_change": '',
          "7d_change": '',
          "30d_change": '',
          tvl: '0',
          dominance: '0%',
          url: 'https://metapool.app/',
        },
        {
          id: '4',
          protocol: 'LiNEAR Protocol',
          logo: require('@/assets/images/logo/linear-protocol.png'),
          "24h_change": '',
          "7d_change": '',
          "30d_change": '',
          tvl: '0',
          dominance: '0%',
          url: 'https://linearprotocol.org/',
        },
        {
          id: '5',
          protocol: 'Stader',
          logo: require('@/assets/images/logo/stader.png'),
          "24h_change": '',
          "7d_change": '',
          "30d_change": '',
          tvl: '0',
          dominance: '0%',
          url: 'https://near.staderlabs.com/',
        },
        {
          id: '6',
          protocol: 'Jumbo Exchange',
          logo: require('@/assets/images/logo/jumbo-exchange.png'),
          "24h_change": '',
          "7d_change": '',
          "30d_change": '',
          tvl: '0',
          dominance: '0%',
          url: 'https://jumbo.exchange/',
        },
        {
          id: '7',
          protocol: 'Spin',
          logo: require('@/assets/images/logo/spin.png'),
          "24h_change": '',
          "7d_change": '',
          "30d_change": '',
          tvl: '0',
          dominance: '0%',
          url: 'https://spin.fi/',
        },
        
      ],
      currentTVL: 1,
    }
  },
  methods: {
    dFormatter,
  },
  mounted () {
    // query TVL Data
    const tvlEndpoint = 'https://api.llama.fi/charts/Near'
    axios.get(tvlEndpoint)
    .then(response => {
      this.currentTVL = response.data[response.data.length-1].totalLiquidityUSD
      let protocols = [
        {name:'ref-finance', id: 1}, {name:'burrow', id: 2}, {name:'meta-pool', id: 3}, 
        {name:'linear-protocol', id: 4}, {name:'stader', id: 5}, {name:'jumbo-exchange', id: 6}, 
        {name:'spin', id: 7}
      ]
      for (let protocol in protocols){
        const endpoint = `https://api.llama.fi/protocol/${protocols[protocol].name}`
        axios.get(endpoint)
        .then(response => {
          if(protocols[protocol].name == 'stader'){
            var lastTVL = response.data["chainTvls"]["Near"]["tvl"][response.data["chainTvls"]["Near"]["tvl"].length - 1].totalLiquidityUSD
            var hTVL = response.data["chainTvls"]["Near"]["tvl"][response.data["chainTvls"]["Near"]["tvl"].length - 2].totalLiquidityUSD
            var dTVL = response.data["chainTvls"]["Near"]["tvl"][response.data["chainTvls"]["Near"]["tvl"].length - 8].totalLiquidityUSD
            var mTVL = response.data["chainTvls"]["Near"]["tvl"].length > 31 ? response.data["chainTvls"]["Near"]["tvl"][response.data["chainTvls"]["Near"]["tvl"].length - 31].totalLiquidityUSD : ""
          }
          else{
            var lastTVL = response.data["tvl"][response.data["tvl"].length - 1].totalLiquidityUSD
            var hTVL = response.data["tvl"][response.data["tvl"].length - 2].totalLiquidityUSD
            var dTVL = response.data["tvl"][response.data["tvl"].length - 8].totalLiquidityUSD
            var mTVL = response.data["tvl"].length > 31 ? response.data["tvl"][response.data["tvl"].length - 31].totalLiquidityUSD : ""
          }
          this.items.find(o => o.id == protocols[protocol].id).tvl = '$'+dFormatter(lastTVL)
          this.items.find(o => o.id == protocols[protocol].id)["24h_change"] = ((lastTVL - hTVL)/hTVL * 100).toFixed(2) + '%'
          this.items.find(o => o.id == protocols[protocol].id)["7d_change"] = ((lastTVL - dTVL)/dTVL * 100).toFixed(2) + '%'
          this.items.find(o => o.id == protocols[protocol].id)["30d_change"] = mTVL !== '' ? ((lastTVL - mTVL)/mTVL * 100).toFixed(2) + '%' : '--'
          this.items.find(o => o.id == protocols[protocol].id).dominance = (lastTVL/this.currentTVL * 100).toFixed(2) + '%'
        })
        .catch(e => {
          console.error(e)
        })
      }
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>
<style>

</style>
